import React from "react";

interface DashboardBreadcrumbsProps {
  current: string;
}

const DashboardBreadcrumbs: React.FC<DashboardBreadcrumbsProps> = ({
  current,
}) => (
  <nav
    className="flex items-center text-sm text-muted-foreground mb-2"
    aria-label="Breadcrumb">
    <a href="/dashboard" className="hover:underline text-primary">
      Dashboard
    </a>
    <span className="mx-2">/</span>
    <span className="font-semibold text-foreground">{current}</span>
  </nav>
);

export default DashboardBreadcrumbs;
